/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, string, shape, arrayOf, bool, func,
} from 'prop-types';
import { compose } from 'recompose';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import ReactHtmlParser from 'react-html-parser';
import { uid } from 'react-uid';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import MuiTabMenuStyle from './MuiTabMenuStyle';

const styles = (theme) => MuiTabMenuStyle(theme);

class MuiTabMenu extends PureComponent {
    getActivePath = () => {
        const { history } = this.props;
        const location = history?.location || {};
        return `${(location.pathname || '')}${(location.hash || '')}`;
    }

    getMenuItem = (menuItem, index) => {
        if (!menuItem?.link?.link) return null;
        const { trackEvent } = this.props;
        const linkData = menuItem.link.link;
        return (
            <Tab
                key={uid(menuItem, index)}
                onClick={() => {
                    trackEvent({
                        eventCategory: menuItem?.link?.tracking_event_category || '',
                        eventAction: menuItem?.link?.tracking_event_action || '',
                        eventLabel: menuItem?.link?.tracking_event_label || '',
                        eventName: 'feature_interaction', // Requird for GA4 feature_click
                    });
                }}
                label={ReactHtmlParser(linkData?.title)}
                id={`vertical-tab-${index}`}
                aria-controls={`vertical-tabpanel-${index}`}
                value={linkData?.href}
            />
        );
    }

    handleSubMenuChange = (event, newValue) => {
        const { history } = this.props;
        if (newValue) {
            history.push(newValue);
        }
    };

    setLayout = () => {
        const { classes, data } = this.props;
        if (!data) return null;
        const links =  (data.links?.length) ? data.links : [];
        const headTitle = (data.title || '');
        return (
            <Grid item xs={12} md={12}>
                <Typography variant="subtitle1" className={classes.headTitle}>{headTitle}</Typography>
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={this.getActivePath()}
                    onChange={this.handleSubMenuChange}
                    aria-label="Customer Service Sub Menu"
                    className={classes.tabs}
                >
                    {links.map((menuItem, index) => (
                        this.getMenuItem(menuItem, index)
                    ))}
                </Tabs>
            </Grid>
        );
    }

    render() {
        return this.setLayout();
    }
}

MuiTabMenu.propTypes = {
    classes: object.isRequired,
    data: shape({
        links: arrayOf(shape({
            link: shape({
                add_icon: bool.isRequired,
                is_child: bool.isRequired,
                link: shape({
                    href: string.isRequired,
                    title: string.isRequired,
                }).isRequired,
                tracking_event_label: string.isRequired,
            }).isRequired,
        })).isRequired,
        locale: string.isRequired,
        orientation: string.isRequired,
        presentation: string.isRequired,
        styles: arrayOf(shape({
            color: shape({
                background_color: shape({
                    color: string.isRequired,
                    colorDescription: string.isRequired,
                    colorTheme: string.isRequired,
                    colorTransparency: string.isRequired,
                    version: string,
                }).isRequired,
                copy_color: shape({
                    color: string.isRequired,
                    colorDescription: string.isRequired,
                    colorTheme: string.isRequired,
                    colorTransparency: string.isRequired,
                    version: string,
                }).isRequired,
                copy_hover_color: shape({
                    color: string.isRequired,
                    colorDescription: string.isRequired,
                    colorTheme: string.isRequired,
                    colorTransparency: string.isRequired,
                    version: string,
                }).isRequired,
            }).isRequired,
        })).isRequired,
        title: string.isRequired,
        uid: string.isRequired,
        _content_type_uid: string.isRequired,
    }).isRequired,
    history: object.isRequired,
    trackEvent: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

const enhance = compose(
    withRouter,
    connect(null, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
);

export default enhance(MuiTabMenu);
